import styled from '@emotion/styled';

const INITIAL_HEIGHT = '40px';
const INITIAL_WIDTH = 'auto';

// Helper function to scale size values (supports rem, px, em, auto)
const scaleSize = (
  size: string | undefined,
  scale: number,
  fallback: string,
): string => {
  if (!size || size === 'auto') return size || fallback;

  const match = size.match(/^(\d+\.?\d*)(rem|px|em)$/);
  if (!match) return size;

  const value = parseFloat(match[1]) * scale;
  const unit = match[2];
  return `${value.toFixed(2)}${unit}`;
};

export const Logo = styled.img<{
  height?: string;
  width?: string;
}>`
  /* Desktop size - use props or defaults */
  height: ${(props) => props.height || INITIAL_HEIGHT};
  width: ${(props) => props.width || INITIAL_WIDTH};
  object-fit: contain;

  /* RWD - Tablet (768px and below) - Scale to 80% */
  @media (max-width: 768px) {
    height: ${(props) => scaleSize(props.height, 0.8, INITIAL_HEIGHT)};
    width: ${(props) =>
      props.width && props.width !== 'auto'
        ? scaleSize(props.width, 0.8, INITIAL_WIDTH)
        : props.width || INITIAL_WIDTH};
  }

  /* RWD - Mobile (480px and below) - Scale to 60% */
  @media (max-width: 480px) {
    height: ${(props) => scaleSize(props.height, 0.6, INITIAL_HEIGHT)};
    width: ${(props) =>
      props.width && props.width !== 'auto'
        ? scaleSize(props.width, 0.6, INITIAL_WIDTH)
        : props.width || INITIAL_WIDTH};
  }
`;
